import React from 'react';
import { cn } from '../../lib/utils';

/**
 * ScaleBase icon, C1: terracotta headstock, paper pegs, terracotta tuner buttons.
 * Source of truth: docs/Logo Exports/ScaleBase_Icon_C1.svg (viewBox 0 0 100 120).
 * Colours are fixed brand colours, so the icon looks the same in light and dark.
 * Decorative by default; pass aria-hidden={false} and an aria-label to expose it.
 */
export function LogoIcon({ className, 'aria-hidden': ariaHidden = true, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 120"
      aria-hidden={ariaHidden}
      focusable="false"
      className={cn('h-[30px] w-auto shrink-0 select-none', className)}
      {...props}
    >
      <g fill="#A94A36">
        <circle cx="12" cy="28" r="7.25" />
        <circle cx="12" cy="46" r="7.25" />
        <circle cx="12" cy="64" r="7.25" />
        <circle cx="88" cy="28" r="7.25" />
        <circle cx="88" cy="46" r="7.25" />
        <circle cx="88" cy="64" r="7.25" />
        <path d="M26 8H74Q78 8 77.7 12L73 76C72 86 64 92 64 100V112H36V100C36 92 28 86 27 76L22.3 12Q22 8 26 8Z" />
      </g>
      <g fill="#F8F5EC">
        <circle cx="38" cy="28" r="6.5" />
        <circle cx="38" cy="46" r="6.5" />
        <circle cx="38" cy="64" r="6.5" />
        <circle cx="62" cy="28" r="6.5" />
        <circle cx="62" cy="46" r="6.5" />
        <circle cx="62" cy="64" r="6.5" />
      </g>
    </svg>
  );
}

/**
 * Icon + "ScaleBase" wordmark (Nunito Sans 800, ink), the header lockup.
 * Phone: 32px-tall icon, 18px wordmark, 8px gap (boards 18/20 had 30 / 17).
 * Desktop (lg): 44px icon, 24px wordmark, 10px gap, so the brand reads at a glance in the
 * wider header (Oct 2026; the header grows to 68px to fit it).
 */
export function Logo({ className, ...props }) {
  return (
    <span
      className={cn('inline-flex items-center gap-2 text-foreground select-none lg:gap-2.5', className)}
      {...props}
    >
      <LogoIcon className="h-8 lg:h-11" />
      <span className="text-[18px] font-extrabold leading-none lg:text-[24px]">
        ScaleBase
      </span>
    </span>
  );
}
